<template>
    <div class="breadcrumb-container">
        <el-breadcrumb separator="/">
            <!-- 面包屑项 - 禁用当前页面的点击 -->
            <el-breadcrumb-item v-for="(item, index) in breadcrumbList" :key="index"
                :to="isCurrentPage(item.path) ? null : item.path"
                :class="{ 'breadcrumb-disabled': isCurrentPage(item.path) }"
                @click.native="handleBreadcrumbClick(item.path)">
                {{ item.name }}
            </el-breadcrumb-item>
        </el-breadcrumb>
    </div>
</template>

<script>
export default {
    name: 'BreadcrumbNav',
    props: {
        // 举报类型映射 - 用于动态路由解析
        reportTypeMap: {
            type: Object,
            default: () => ({
                '0': '帖子举报',
                '1': '帖子申诉',
                '2': '圈子投诉',
                '3': '管理投诉',
                '4': '用户举报',
                '5': '评论举报',
                '6': '回复评论举报'
            })
        },
        // 路由面包屑映射配置
        routeBreadcrumbMap: {
            type: Object,
            required: true
        }
    },
    computed: {
        // 获取当前路由信息
        $route() {
            return this.$root.$route
        },
        // 生成面包屑列表（支持动态路由）
        breadcrumbList() {
            const currentPath = this.$route.path

            // 处理动态路由 /cardReport/:typeId
            if (currentPath.startsWith('/cardReport')) {
                const typeId = this.$route.params.typeId || '0'
                const typeName = this.reportTypeMap[typeId] || '举报管理'
                return [
                    { path: '/home', name: '首页' },
                    { path: '/', name: '举报管理' },
                    { path: currentPath, name: typeName }
                ]
            }

            // 匹配静态路由
            return this.routeBreadcrumbMap[currentPath] || [{ path: '/home', name: '首页' }]
        }
    },
    watch: {
        // 监听路由变化，确保面包屑实时更新
        '$route'(to, from) {
            // 路由变化时自动更新面包屑
        }
    },
    methods: {
        // 判断是否为当前页面路径
        isCurrentPage(path) {
            const currentPath = this.$route.path

            // 处理动态路由的特殊情况
            if (currentPath.startsWith('/cardReport') && path.startsWith('/cardReport')) {
                return true
            }

            // 处理模块级别的空路径
            if (path === '/' && currentPath !== '/home') {
                return false
            }

            // 普通路径匹配
            return path === currentPath
        },
        // 面包屑点击事件处理
        handleBreadcrumbClick(path) {
            // 如果是当前页面，阻止跳转
            if (this.isCurrentPage(path)) {
                // 可选择触发自定义事件，供父组件处理提示
                this.$emit('current-page-click', path)
                return false
            }
            return true
        }
    }
}
</script>

<style lang="scss" scoped>
.breadcrumb-container {
    flex: 1;
    margin: 0 20px;
    color: #666;

    ::v-deep .el-breadcrumb {
        font-size: 14px;
    }

    ::v-deep .el-breadcrumb__item:last-child .el-breadcrumb__inner {
        color: #333;
        font-weight: 500;
    }

    // 禁用状态样式
    ::v-deep .breadcrumb-disabled {
        pointer-events: none; // 禁止鼠标事件
        cursor: not-allowed; // 显示禁止光标

        .el-breadcrumb__inner {
            color: #999 !important; // 灰色文字
            font-weight: normal !important;
        }

        .el-breadcrumb__inner a {
            color: #999 !important;
            text-decoration: none;
        }
    }
}
</style>